import React, { useState } from 'react';
import { LocalizationContext } from '../App';
import { Link, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import LaunchIcon from '@mui/icons-material/Launch';
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import uuid from 'react-uuid';
import { red } from '@mui/material/colors';
import Backdrop from '@mui/material/Backdrop';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea, CardActions } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';


const LoupeActivityList = props => {

    const language = props.language;
    const activities = props.data;   
    const position = props.position;

    const [ showConfirmationDialog, setShowConfirmationDialog ] = React.useState(false);
    const [ storedActivity, setStoredActivity ] = React.useState(null);
    
    const navigate = useNavigate();

    const handleOpenActivityDirect = () => {
        setShowConfirmationDialog(false);        
        var i = storedActivity;
        navigate('/activity-content/' + i.activityLanguage + "/" + i.SurveyCode, { replace : true, state : { activity : i } } ); 

    }
    const handleCancel = () => {
        setShowConfirmationDialog(false);
    }
    const handleOpenDetails = () => {
        setShowConfirmationDialog(false);
        var i = storedActivity;
        navigate("/activity-details/" + i.activityLanguage + "/" + i.SurveyCode, { state : { activity : i } });
    }


    const openActivityDetails = (i) => { 
        i['latitude'] = position.coords.latitude;
        i['longitude'] = position.coords.longitude;
        i['accuracy'] = position.coords.accuracy;
        i['source'] = 'location';
        i['sessionId'] = uuid();
        navigate("/activity-details/" + i.activityLanguage + "/" + i.SurveyCode, { state : { activity : i } });
    }

    const openActivityDirect = (i) => {
        i['latitude'] = position.coords.latitude;
        i['longitude'] = position.coords.longitude;
        i['accuracy'] = position.coords.accuracy;
        i['source'] = 'location';
        i['sessionId'] = uuid();
        setStoredActivity(i);
        setShowConfirmationDialog(true);
    }

    const [ showSnackbar, setShowSnackbar ] = React.useState(true);

    const closeSnack = () => {
        setShowSnackbar(false);
    }

    return (

        <LocalizationContext.Consumer>
            { ({strings}) =>   
                <>         
                <div className="mb-8">

                    { activities.length == 0 &&                     
                        <React.Fragment>

                            <p className="mb-6" />
                            
                            <Typography variant="h4" className="mb-3" gutterBottom>{strings.getString("errors.noactivities.title")}</Typography>
                            <Typography variant="body2">{strings.getString("errors.noactivities.message")}</Typography>
                            
                            {/* <Snackbar open={showSnackbar} autoHideDuration={4000} anchorOrigin={{horizontal:'right',vertical:'top'}} onClose={closeSnack}>
                                <Alert onClose={closeSnack} severity="error" className="text-start">
                                    {strings.getString("errors.noactivities.snack")}
                                </Alert>
                            </Snackbar> */}
                            
                        </React.Fragment>
                    }

                    <List>
                    {/* <Stack direction="column"> */}
                        { activities.map(i => {
                            return(
                                <React.Fragment key={'div_' + i.Title} >
                                    
                                    {/* <Paper className="mb-3" elevation={1} sx={{ padding : '5px'}}> */}
                                        <ListItem className="point mb-3" 
                                            secondaryAction={
                                            
                                            <IconButton edge="end" aria-label="comments" onClick={() => openActivityDirect(i)}>
                                                <LaunchIcon />
                                            </IconButton>
                                        }>
                                        <ListItemText 
                                            primary={<Typography onClick={() => openActivityDetails(i)} variant="h6">{i.Title}</Typography>}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.tertiary">{i.Keywords}</Typography>
                                                    <Typography onClick={() => openActivityDetails(i)} sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">{" — " + i.ShortInfo}</Typography>                                   
                                                </React.Fragment>}/>
                                            </ListItem>
                                            {/* <Divider className="mt-2 mb-2" /> */}
                                        {/* </Paper> */}
                                </React.Fragment>                            
                            )
                        }) 
                        }
                       
                    {/* </Stack> */}
                    </List>

                </div>  
                <div></div> 

                <Backdrop open={showConfirmationDialog} sx={{color : '#000'}} />
                <Dialog
                    open={showConfirmationDialog}                      
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                
                    <DialogTitle id="alert-dialog-title">
                    {strings.getString("dialogs.activity.opendirect.title")}
                    </DialogTitle>
                    <DialogContent>
                        <Typography component="div" variant="body">{strings.getString("dialogs.activity.opendirect.message")}</Typography>
                        <p/>
                        <Typography component="div" variant="caption">{strings.getString("texts.activity.consent")}</Typography>                                                       
                    </DialogContent>

                    <DialogActions>
                    <Button onClick={handleOpenDetails}>{strings.getString("controls.buttons.activity.details")}</Button>
                    <Button onClick={handleCancel}>{strings.getString("controls.buttons.no")}</Button>
                    <Button onClick={handleOpenActivityDirect} autoFocus>
                        {strings.getString("controls.buttons.yes")}
                    </Button>
                    </DialogActions>
                </Dialog>

                </>         
            }
        </LocalizationContext.Consumer>
        
    );    
}
export default LoupeActivityList;